import { createApp } from 'vue'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import locale from 'element-plus/es/locale/lang/zh-cn'

import App from './App'
import pinia from './store' // 新增
import router from './router'
import directive from './directive' // directive

// 分页组件
import Pagination from '@/components/Pagination'
// 富文本组件
import Editor from '@/components/Editor'

import './styles/main.scss'
import './styles/common.scss'

import VxeUIBase from 'vxe-pc-ui'
import 'vxe-pc-ui/es/style.css'
import VxeUITable from 'vxe-table'
import 'vxe-table/es/style.css'

// 20260901新增 过滤所有空白字符（包括空格、制表符、换行符等）
import noSpaceDirective from './directive/noSpace';

const app = createApp(App)

app.use(router) // 新增：使用 Vue Router
app.use(pinia) // 新增：使用 Pinia
app.use(VxeUIBase) // 新增：使用 VxeUIBase
app.use(VxeUITable) // 新增：使用 VxeUITable

app.component('Pagination', Pagination)
app.component('Editor', Editor)

directive(app)

// 20260901新增 全局注册指令
app.directive('no-space', noSpaceDirective);

// 使用element-plus 并且设置全局的大小
app.use(ElementPlus, {
	locale: locale,
	// 支持 large、default、small
	size: 'default'
})

app.mount('#app')